
import HeroSection from './components/HeroSection';
import CommitmentSection from './components/CommitmentSection';
import SustainablePracticesSection from './components/SustainablePracticesSection';
import EthicalProductionSection from './components/EthicalProductionSection';
import CertificationsSection from './components/CertificationsSection';
import PromiseSection from './components/PromiseSection';

export default function Sustainability() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <CommitmentSection />
      <SustainablePracticesSection />
      <EthicalProductionSection />
      <CertificationsSection />
      <PromiseSection />
    </div>
  );
}
